import { render, staticRenderFns } from "./CardContatoResponsavel.vue?vue&type=template&id=522cd306&scoped=true"
import script from "./CardContatoResponsavel.vue?vue&type=script&lang=ts"
export * from "./CardContatoResponsavel.vue?vue&type=script&lang=ts"
import style0 from "./CardContatoResponsavel.vue?vue&type=style&index=0&id=522cd306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522cd306",
  null
  
)

export default component.exports